import React from 'react';
import { connect } from 'react-redux';
import Input from '@bit/knotchinc.web-react-components.input';
import { debounce } from 'lodash';
import FilterContainer from '@bit/knotchinc.web-react-components.filter-container';
import Box from '@bit/knotchinc.web-react-components.box';

export class SearchFilter extends React.Component {
  constructor(props) {
    super(props);
    const { filterAction, searchBy, setFilters } = props;
    this.search = debounce(value => setFilters({
      searchQuery: value,
      searchBy: value ? searchBy : null,
      pageNum: 1,
    }, filterAction), 200);
  }

  render() {
    return (<FilterContainer title={this.props.title || 'Search'}>
      <Box pt="12px" height="50px">
        <Input
          hideErrorText
          placeholder="Search..."
          callback={this.search}
        />
      </Box>
    </FilterContainer>);
  }
}

SearchFilter.defaultProps = {
  searchBy: 'title',
};

const mapDispatchToProps = dispatch => ({
  setFilters: (filters, type) => dispatch({ type, filters }),
});

export default connect(null, mapDispatchToProps)(SearchFilter);
